<!-- 底部 -->
<template>
  <header id="footer">
    <div class="warp">
      <span>沪ICP备19032968号</span>
      <span>©2020 上海方盒信息咨询有限公司 All rights reserved.</span>
    </div>
  </header>
</template>

<script>

export default {
  name: 'foote',
  data () {
    return {
      statistics: {
        currency: 0,
        material: 0
      }
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="less">
  #footer {
    background: #0d0d0d;
    .warp {
      font-size: 14px;
      color: #999;
      height: 70px;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue